import { render, staticRenderFns } from "./accountsReceiveDataSource.vue?vue&type=template&id=b7c59d16&scoped=true&"
import script from "./accountsReceiveDataSource.vue?vue&type=script&lang=js&"
export * from "./accountsReceiveDataSource.vue?vue&type=script&lang=js&"
import style0 from "./accountsReceiveDataSource.vue?vue&type=style&index=0&id=b7c59d16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c59d16",
  null
  
)

export default component.exports